import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface CheckboxStyleProps {
  disabled: boolean
  articleVariant: boolean
}

const useStyles = makeStyles<Theme, CheckboxStyleProps>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  articleTable: {
    '& svg': {
      marginLeft: '0.25rem',
      marginRight: '0.25rem',
      marginBottom: '0',
      fontSize: theme.size.sm
    }
  },

  text: {
    cursor: ({ disabled }) => (disabled ? 'not-allowed' : 'pointer'),
    userSelect: 'none',
    fontSize: theme.size.sm
  },

  checkbox: {
    marginRight: ({ articleVariant }) => (articleVariant ? '0' : '0.75rem')
  }
}))

export default useStyles
